import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from '@mui/material';
import colors from '../theme/Colors';

const ShipOrderModal = ({
    open,
    handleClose,
    initialData,
    onShip
}) => {
    console.log("data:",initialData);
    const [localData, setLocalData] = useState({
        shipped_date: '',
        shipped_via: ''
    });
    const [errors, setErrors] = useState({ shipped_date: false, shipped_via: false });

    useEffect(() => {
        if (open) {
            setLocalData(initialData || { shipped_date: '', shipped_via: '' });
            setErrors({ shipped_date: false, shipped_via: false });
        }
    }, [open, initialData]);

    const handleModalClose = () => {
        handleClose();
        setLocalData({ shipped_date: '', shipped_via: '' });
        setErrors({ shipped_date: false, shipped_via: false });
    };

    const handleShip = () => {
        let hasError = false;
        const newErrors = { shipped_date: false, shipped_via: false };

        if (!localData.shipped_date) {
            newErrors.shipped_date = true;
            hasError = true;
        }
        if (!localData.shipped_via.trim()) {
            newErrors.shipped_via = true;
            hasError = true;
        }

        setErrors(newErrors);

        if (!hasError) {
            onShip(localData);
            handleModalClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleModalClose}
            maxWidth="sm"
            fullWidth
            BackdropProps={{
                style: { backgroundColor: "transparent" }
            }}
        >
            <DialogTitle>Ship Order</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Shipping Details
                    </Typography>

                    <TextField
                        label="Shipped Date"
                        type="date"
                        value={localData.shipped_date}
                        onChange={(e) =>
                            setLocalData((prev) => ({
                                ...prev,
                                shipped_date: e.target.value
                            }))
                        }
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: 250 }}
                        error={errors.shipped_date}
                        helperText={errors.shipped_date ? "Please select a shipped date" : ""}
                    />

                    <TextField
                        label="Shipped Via"
                        value={localData.shipped_via}
                        onChange={(e) =>
                            setLocalData((prev) => ({
                                ...prev,
                                shipped_via: e.target.value
                            }))
                        }
                        placeholder="e.g. FedEx"
                        sx={{ width: 250 }}
                        error={errors.shipped_via}
                        helperText={errors.shipped_via ? "Please enter carrier name" : ""}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleModalClose}>Cancel</Button>
                <Button onClick={handleShip} variant="contained" sx={{backgroundColor: '#1abc9c'}}>
                    Ship Order
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ShipOrderModal;
